import { checkPageSetting } from "@/components/LoginModal";
import { getMe } from "@/services";
import { setTrackerUser } from "@/tracker";
import { setGdSlsRumUser } from "@/utils/gdSlsRum";

export default function user(set) {
  return {
    /**
     * @type {IUser}
     */
    user: null,
    userReady: false,
    // 刷新用户信息，自动调用getMe接口
    async refreshUser() {
      const userResult = await getMe();
      set({
        user: !userResult.err ? userResult : null,
        userReady: true,
      });
      // 更新埋点用户信息
      setTrackerUser(userResult.err ? null : userResult);
      // 判断用户是否保存了配置信息，如果有的话替换本地的配置信息
      checkPageSetting(userResult);
      setGdSlsRumUser(userResult.err ? null : userResult);

      return userResult;
    },
    setUser(user) {
      set({
        user: user,
        userReady: true,
      });

      setTrackerUser(user);
      checkPageSetting(user);
      setGdSlsRumUser(user);
    },
  };
}
